<div class="container" *transloco="let t">
  <div class="title">
    <div class="title">
      <span>{{ t(settingOption.displayName) }}</span>
    </div>
    <div>
      <app-svg-icon class="icon" [path]="'/assets/closebutton.svg'" (click)="closeEvent.emit(true)"/>
    </div>
  </div>
  <div class="box">
    <div class="option">
      @for (value of settingOption.availableValues; track value) {
        <app-fancy-button class="selectable"
                          [ngClass]="{small: isFontSetting()}"
                          [title]="t(value.label)"
                          [type]="isLanguageSetting() ? buttonType.Flag : undefined"
                          [selected]="value.value === settingOption.selectedValue.value"
                          (click)="setValue(value)"/>
      }
    </div>
    @if (isFontSetting()) {
      <div class="example">
        <p class="preview">{{ t('POPUPS.SETTINGS-POPUP.PREVIEW-TITLE') }}</p>
        <p class="bold">{{ t('POPUPS.SETTINGS-POPUP.PREVIEW-BOLD') }}</p>
        <p>{{ t('POPUPS.SETTINGS-POPUP.PREVIEW-TEXT') }}</p>
      </div>
    }
  </div>
</div>
